import { render, staticRenderFns } from "./carCodeBox.vue?vue&type=template&id=04d5845f&scoped=true&"
import script from "./carCodeBox.vue?vue&type=script&lang=js&"
export * from "./carCodeBox.vue?vue&type=script&lang=js&"
import style0 from "./carCodeBox.vue?vue&type=style&index=0&id=04d5845f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5845f",
  null
  
)

export default component.exports